module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-3-78fef80c1371f3b7bda416988d88cc89.png";